const toggleSwitchTemplate = require('sma.admin/components/partials/switch.mustache');
const DatePicker = require('sma.admin/components/datepicker');

let ToggleField = Backbone.View.extend({
	events: {
		'change .sma-js-slide-toggle-checkbox': 'clickToggle'
	},

	States: {
		TOGGLE_OFF: 0,
		TOGGLE_ON: 1
	},

	initialize: function(config) {
		this.setElement(config.element[0]);

		this.$parent = this.$el.parents('fieldset:first');
		this.$inputs = this.$parent.find('input,select,textarea').not('input[type="checkbox"],.sma-js-slide-toggle-checkbox');

		this.build();

		this.determineState();
	},

	build: function() {
		if (this.$el.find('.sma-js-slide-toggle-checkbox:first').length > 0) {
			this.$toggler = this.$parent.find('.sma-js-slide-toggle-checkbox:first');
			return;
		}


		let label = this.$el.data('label') ? this.$el.data('label') : '';

		this.$el.append($(toggleSwitchTemplate({
			id: this.$inputs.eq(0).attr('id'),
			label: label
		})));

		this.$toggler = this.$parent.find('.sma-js-slide-toggle-checkbox:first');
	},

	clickToggle: function(e) {
		e.preventDefault();

		if (this.state === this.States.TOGGLE_OFF) {
			this.state = this.States.TOGGLE_ON;
		} else {
			this.state = this.States.TOGGLE_OFF;
			this.toggleOff();
		}

		this.update();
	},

	toggleOff: function() {
		this.$inputs.not(':button, :submit, :reset, :hidden, .sma-js-slide-toggle-checkbox')
			.val('')
			.removeAttr('checked')
			.removeAttr('selected');
	},

	determineState: function() {
		this.state = this.States.TOGGLE_OFF;

		this.$inputs.each((i, input) => {
			let input_val = input.val();

			if (input_val !== null && (input_val.hasOwnProperty('length') && input_val.length > 0) && input_val !== '' && input_val !== '-1') {
				this.state = this.States.TOGGLE_ON;
				return false;
			}
		});

		this.update();
	},

	update: function() {
		if (this.state === this.States.TOGGLE_ON) {
			this.$toggler.attr('checked', 'checked');
			this.$parent.find('.sma-js-toggle-content').show();
		} else {
			this.$toggler.removeAttr('checked');
			this.$parent.find('.sma-js-toggle-content').hide();
		}
	}
});

let LockedInput = Backbone.View.extend({
	events: {
		'click .sma-js-confirm-lock': 'confirm',
		'click .sma-js-edit-lock': 'edit'
	},

	States: {
		LOCKED: 0,
		EDITING: 1
	},

	initialize: function(config) {
		this.setElement(config.element[0]);

		this.$edit_button = this.$el.find('.sma-js-edit-lock');
		this.$confirm_button = this.$el.find('.sma-js-confirm-lock');
		this.$input = this.$el.find('input:first');

		this.state = this.States.LOCKED;
		this.update();
	},

	update: function() {
		if (this.state === this.States.LOCKED) {
			this.setLocked();
		} else if (this.state === this.States.EDITING) {
			this.setEditable();
		}
	},

	setLocked: function() {
		this.$input.addClass('disabled');
		this.$input.attr('readonly', 'readonly');
		this.$confirm_button.hide();
		this.$edit_button.show();
	},

	setEditable: function() {
		this.$input.removeClass('disabled');
		this.$input.removeAttr('readonly');
		this.$edit_button.hide();
		this.$confirm_button.show();
	},

	edit: function(e) {
		e.preventDefault();

		this.state = this.States.EDITING;
		this.update();
	},

	confirm: function(e) {
		e.preventDefault();

		this.state = this.States.LOCKED;
		this.update();
	}
});

//When using SectionedForm and FormSections with nested forms
// this is handy to show a form based on another fields current
// value
let FormToggler = Backbone.View.extend({
	initialize: function(config) {
		//When the elements affected don't exist in the DOM yet
		//   this needs to be passed in to be bound on
		this.parentElement = config.parentElement || $('body');
		this.setElement(config.element[0]);
		this.$input = config.input;

		let affects = this.$el.attr('data-form-toggler').split(',');

		this.affectMap = {};

		for (let affect of affects) {
			let affectEl = this.parentElement.find(affect);

			let val = affectEl.attr('data-selector-val');

			this.affectMap[val] = affectEl;
			affectEl.hide();
		}

		this.$input.on('change', $.proxy(this.update, this));
		this.update();
	},

	update: function(e) {
		let val = this.$input.val();

		for (let k in this.affectMap) {
			if (k == val) {
				this.affectMap[k].show();
			} else {
				this.affectMap[k].hide();
			}
		}
	}
});

/*
For radio buttons and checkboxes despite name.
Checkbox usage is simple
element - the div to be shown and hidden
data-when-checked - the checkbox or radio(use input[name='group name']) to monitor
when using radio buttons make sure it also has
data-check-for-value set to the value of the radio button you want to make show the div
*/
let WhenChecked = Backbone.View.extend({
	initialize: function(config) {
		//When the elements affected don't exist in the DOM yet
		//   this needs to be passed in to be bound on

		this.setElement(config.element[0]);

		this.parentElement = config.parentElement || $('body');

		if (this.$el.attr('data-from-parent') !== undefined) {
			this.parentElement = this.$el.parents(this.$el.attr('data-from-parent'));
		}

		/* APPLY-1661: Post webpack migration bug fix/hack to make jquery objects work properly */
		this.parentElement = $(this.parentElement);

		let $input = this.parentElement.find(this.$el.attr('data-when-checked'));

		this.isSelect = $input.length ? $input[0].tagName.toLowerCase() == 'select' : false;

		this.parentElement.on('change', this.$el.attr('data-when-checked'), $.proxy(this.inputChanged, this));

		this.clearValueOnChange = config.clearValueOnChange || false;

		this.inputChanged();
	},

	inputChanged: function(e) {
		let $input = this.parentElement.find(this.$el.attr('data-when-checked'));
		let isChecked = false;
		let action = this.$el.attr('data-action') || 'show';
		let $target = this.$el;
		let targetSelector = this.$el.attr('data-target');

		if (targetSelector) {
			$target = $(targetSelector);
		}

		if (this.isSelect) {
			if ($input.val() == this.$el.attr('data-check-for-value')) {
				isChecked = true;
			}
		} else if ($input.length > 1) {
			for (let i = 0; i < $input.length; i++) {
				if ($input.eq(i).attr('value') == this.$el.attr('data-check-for-value') && $input.eq(i).is(':checked')) {
					isChecked = true;
					break;
				}
			}
		} else {
			isChecked = $input.is(':checked');
			let checkForValue = this.$el.attr('data-check-for-value');

			if (checkForValue != undefined) {
				checkForValue = checkForValue == 'true';
				isChecked = isChecked == checkForValue;
			}
		}

		if (action === 'show') {
			if (this.clearValueOnChange && !isChecked) {
				$target.find('input,select,textarea').not('input[type="checkbox"],.sma-js-slide-toggle-checkbox,.picker__select--year,.picker__select--month').val('');
			}
			if (isChecked) $target.show();
			else $target.hide();

		} else if (action === 'disable') {
			if (isChecked) $target.prop('disabled', true);
			else $target.prop('disabled', false);
		}

	}
});

const initWhenChecked = function () {
	$('.sma-js-toggled-by-checkbox').each(function() {
		new sma.components.Forms.WhenChecked({
			element: $(this)
		});
	});
};

const datePickerInit = function () {
	$('.sma-js-date-picker').each(function() {
		new DatePicker($(this));
	});
};

module.exports = {
	LockedInput,
	ToggleField,
	FormToggler,
	WhenChecked,
	initWhenChecked,
	datePickerInit,
	DatePicker
};
